export const adminSections = [
  "dashboard",
  "pelanggan",
  "voucher",
  "invoice",
  "paket",
  "reseller",
  "tiket",
  "whatsapp",
  "telegram",
  "payment",
  "sesi",
  "radius",
  "olt",
  "peta",
  "odcodp",
  "acs",
  "acslite",
  "isolir",
  "pengeluaran",
  "bhp-uso",
  "laporan",
  "income-report",
  "lap-pelanggan",
  "lap-voucher",
  "net-profit",
  "voucher-template",
  "userio",
  "backup",
  "sistem",
  "setting",
  //"lisensi",
  "pengguna",
  "log",
  "tk-dashboard",
  "r-dashboard",
  "r-voucher",
  "r-pelanggan",
  "r-topup",
  "r-laporan",
  "r-profil",
];
export const clientSections = [
  "dashboard",
  "tagihan",
  "password",
  "tiket",
  "profil",
];
